import {
  AllowedOrderStatusModel,
  DEFAULT_ORDER_SEARCH_PAGE_SIZE,
  OrderModel,
  OrderSearchPeriod,
  OrderStatusModel,
  orderClient,
} from '@merchant-clients/order';

import { useInfiniteScrollClientQuery } from '@frontend/hooks';

export interface UseOrderHistoryQueryProps {
  shopId: string;
  placeIds: string[] | undefined;
  status: OrderStatusModel[] | undefined;
  period: OrderSearchPeriod;
  verificationIds: number[] | undefined;
  onFinally?(): void;
  onError?: (error: Error) => void;
}

export const getOrderHistoryQueryKey = (
  shopId: string,
  filterSignature: string,
) => ['order-history', shopId, filterSignature];

export const useOrderHistoryQuery = ({
  shopId,
  placeIds,
  status,
  period,
  verificationIds,
  onFinally,
  onError,
}: UseOrderHistoryQueryProps) => {
  const filterSignature = JSON.stringify({
    placeIds,
    status,
    period,
    verificationIds,
  });

  return useInfiniteScrollClientQuery<OrderModel>({
    queryKey: getOrderHistoryQueryKey(shopId, filterSignature),
    enabled: !!shopId,
    onFetch: async (pageToken) => {
      return orderClient.listPage({
        pageSize: DEFAULT_ORDER_SEARCH_PAGE_SIZE,
        pageToken,
        filter: {
          shopId,
          placeIds,
          status: status ?? [...AllowedOrderStatusModel],
          period,
          orderIds: undefined,
          verificationIds,
        },
      });
    },
    onFinally,
    onError,
  });
};
